<ng-container [formGroup]="f">
  <div [attr.class]="formItem.rowClass || 'row'">
    <div [attr.class]="formItem.colClass || 'col'">
      @switch (formItem.type) {
        @case ('datePicker') {
          <app-date-field
            [label]="formItem.label"
            [datacy]="formItem.id"
            [controlName]="formItem.id"
            [errorState]="errorState"
            [colClass]="formItem.colClass"
            [minDate]="formItem.datePicker?.minDate"
            [maxDate]="formItem.datePicker?.maxDate"
            [dynamicMinDate]="formItem.datePicker?.dynamicMinDate"
          ></app-date-field>
        }
        @default {
          <mat-form-field appearance="fill">
            <mat-label>{{ formItem.label }}</mat-label>
            @switch (formItem.type) {
              @case ('text') {
                <input type="text" attr.data-cy="{{ formItem.id }}-input" matInput [errorStateMatcher]="errorState" placeholder="" [formControlName]="formItem.id" [required]="formItem.isRequired" [maxLength]="250" (blur)="checkErrors()" />
              }
              @case ('select') {
                <mat-select
                  attr.data-cy="{{ formItem.id }}-input"
                  [errorStateMatcher]="errorState"
                  [placeholder]="formItem.placeholder"
                  [formControlName]="formItem.id"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="$event.target.click()"
                  [required]="formItem.isRequired"
                  (blur)="checkErrors()"
                  (ngModelChange)="valueChanges($event); checkErrors()"
                >
                  @for (menu of isSelectOptionsArray(selectOptions) ? selectOptions : (selectOptions | keyvalue); track $index) {
                    <mat-option role="option" [disabled]="getMatOptionDisabled(menu.value)" [value]="menu.key">
                      {{ getMatOptionValue(menu.value) }}
                    </mat-option>
                  }
                </mat-select>
              }
            }
          </mat-form-field>
          @for (errorTypes of errorTypes$ | async; track $index; let i = $index) {
            <mat-error data-cy="date-error">
              <span class="pb-3">
                <i class="icon-warning_white"></i>
                {{ formItem.errorTextObj[errorTypes] }}
              </span>
            </mat-error>
          }

          @if (getDisabledReasons()) {
            <span>{{ getDisabledReasons() }}</span>
          }
        }
      }
    </div>
  </div>
</ng-container>
